import React, { useEffect, useState } from 'react'
import { postQuirofanosDetalle } from '../../../services/PaginaRuta';
import * as XLSX from 'xlsx';


const ModalQuirofanoDetalle = ({setmodalOnQuirofanoDetalle,dataQuirofanoDetalle,filtroFecha}) => {
  
  const [dataHorasQuirofanos, setdataHorasQuirofanos]=useState([])

    const handleCancelarClick=()=>{
        setmodalOnQuirofanoDetalle(false)
    }

    useEffect(()=>{
      const quirofanoID={
        "ProFec":filtroFecha,
        "ProFecF":filtroFecha,
        "ProCons":dataQuirofanoDetalle.idQuirofano
    }
    postQuirofanosDetalle(quirofanoID).then((res)=>{
      console.log(res.data.DisponibilidadDeHoras,'quirofano detalle')
      setdataHorasQuirofanos(res.data.DisponibilidadDeHoras)
    }).catch((error)=>{
      
    })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto  bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              {dataQuirofanoDetalle.nombreQuirofano}
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-2">

          <div className="flex justify-start items-center space-x-4 pb-3">
          <div className="flex items-center">
            <span className="mr-2">Ocupado/No Disponible</span>
            <div className="w-6 h-6 bg-indigo-400"></div>
          </div>
          <div className="flex items-center">
            <span className="mr-2">Con cupo</span>
            <div className="w-6 h-6 bg-yellow-400"></div>
          </div>
          <div className="flex items-center">
            <span className="mr-2">Disponible</span>
            <div className="w-6 h-6 bg-green-300"></div>
          </div>
          
        </div>

          <div className="overflow-x-auto relative">
      
      <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="py-3 px-3">Hora</th>
            <th scope="col" className="py-3 px-3">Nombre</th>
            <th scope="col" className="py-3 px-3">Hora Inicial</th>
            <th scope="col" className="py-3 px-3">Hora Final</th>
            <th scope="col" className="py-3 px-3">Tiempo disponible</th>
          </tr>
        </thead>
        <tbody>
          
          {dataHorasQuirofanos.map((data, index) => (
            <tr
            className={
              `py-4 px-6 text-black ${
                data.TiempoParaUsar === 60 ? 'bg-green-300' :
                data.TiempoParaUsar < 30 ? 'bg-indigo-400' :
                'bg-yellow-400'
              } border-b dark:border-gray-700`
            }
            key={index}
          >
              <td className="py-4 px-6">{data.Intervalo}</td>
              <td className="py-4 px-6">
              
                {
                data.TiempoParaUsar === 60 ?
                null:
                data.Pacientes.map((usuario, index) => (
                  <React.Fragment key={index}>
                    👤 {usuario.MPNOMC}  {index < data.Pacientes.length - 1 ? <br /> : null}
                  </React.Fragment>
                ))}
              </td>
              <td className="py-4 px-6">
                {
                  data.TiempoParaUsar === 60 ?
                  null:
                data.Pacientes.map((usuario, index) => (
                  <React.Fragment key={index}>
                    {usuario.ProHorI}{index < data.Pacientes.length - 1 ? <br /> : null}
                  </React.Fragment>
                ))}
              </td>
              <td className="py-4 px-6">
                {
                  data.TiempoParaUsar === 60 ?
                  null:
                data.Pacientes.map((usuario, index) => (
                  <React.Fragment key={index}>
                    {usuario.ProHorF}{index < data.Pacientes.length - 1 ? <br /> : null}
                  </React.Fragment>
                ))}
              </td>
              <td className="py-4 px-6">
                {data.TiempoParaUsar} Minutos               
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-1 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-3 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button 
            type="button"
            onClick={() => exportToExcell(dataHorasQuirofanos, 'DetalleQuirofano',dataQuirofanoDetalle.nombreQuirofano)}
            className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-[#9e56fe] hover:shadow-lg focus:bg-[#9e56fe] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#9e56fe] active:shadow-lg transition duration-150 ease-in-out ml-1">
            Exportar a Excel
          </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const prepareDataForExcel = (dataHorasQuirofanos) => {
  return dataHorasQuirofanos.map(data => {
    // Unir información de los pacientes si hay más de uno, junto con sus horas correspondientes.
    let nombresPacientes = '';
    let horasInicio = '';
    let horasFin = '';

    if (data.TiempoParaUsar !== 60 && data.Pacientes) {
      nombresPacientes = data.Pacientes.map(usuario => usuario.MPNOMC.trim()).join("\n");
      horasInicio = data.Pacientes.map(usuario => usuario.ProHorI).join("\n");
      horasFin = data.Pacientes.map(usuario => usuario.ProHorF).join("\n");
    }

    return {
      'Hora': data.Intervalo,
      'Nombre': nombresPacientes || null,
      'Hora Inicial': horasInicio || null,
      'Hora Final': horasFin || null,
      'Tiempo Disponible': `${data.TiempoParaUsar} Minutos` || "60 Minutos"
    };
  });
};

const exportToExcel = (rawData, fileName) => {
  const data = prepareDataForExcel(rawData);

  // Crear un nuevo libro de trabajo
  const workbook = XLSX.utils.book_new();

  // Convertir los datos a un formato de hoja de trabajo
  const worksheet = XLSX.utils.json_to_sheet(data);
  //const worksheet = XLSX.utils.json_to_sheet(data, {skipHeader: true});

  // Establecer el ancho de las columnas
  worksheet['!cols'] = [
    { wpx: 150 }, // Ancho de la columna 'Hora' en píxeles
    { wpx: 200 }, // Ancho de la columna 'Nombre' en píxeles
    { wpx: 150 }, // Ancho de la columna 'Hora Inicial' en píxeles
    { wpx: 150 }, // Ancho de la columna 'Hora Final' en píxeles
    { wpx: 150 }  // Ancho de la columna 'Tiempo Disponible' en píxeles
  ];

  
// Establece la altura de las filas, este valor es un ejemplo, ajústalo según tus necesidades
const rowHeight = 50; // Altura en píxeles

worksheet['!rows'] = data.map(() => ({ hpx: rowHeight }));


// Aplicar ajuste de texto a todas las celdas de la hoja de trabajo
const range = XLSX.utils.decode_range(worksheet['!ref']); // Obtén el rango de todas las celdas

for(let R = range.s.r; R <= range.e.r; ++R) {
  for(let C = range.s.c; C <= range.e.c; ++C) {
    const cellRef = XLSX.utils.encode_cell({c:C, r:R});

    if(worksheet[cellRef]) {
      worksheet[cellRef].s = {
        alignment: {
          wrapText: true, // Esto debería activar el ajuste de texto
          vertical: 'center', // Esto centra verticalmente el texto en la celda
          horizontal: 'left' // Esto alinea horizontalmente el texto a la izquierda en la celda
        }
      };
    }
  }
}
  // Añadir la hoja al libro
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Detalles');

  // Escribir el libro de trabajo
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};



// Función auxiliar para convertir el buffer a Blob
function s2ab(s) {
  const buffer = new ArrayBuffer(s.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buffer;
}



const exportToExcell = (rawData, fileName,nameQuirofano) => {
  const data = prepareDataForExcel(rawData);
  // Crear un nuevo libro de trabajo
  const workbook = XLSX.utils.book_new();

  // Crear una hoja de trabajo desde los datos y dejar espacio para el título y los encabezados
  const worksheet = XLSX.utils.json_to_sheet([], {
    header: ["Hora", "Nombre", "Hora Inicial", "Hora Final", "Tiempo Disponible"],
    skipHeader: true
  });

  // Añadir el título en la primera fila y fusionar las celdas para el título
  const title = nameQuirofano; // Cambia esto por tu título deseado
  XLSX.utils.sheet_add_aoa(worksheet, [[title]], {origin: 'A1'});
  worksheet['!merges'] = [XLSX.utils.decode_range('A1:E1')];

  // Añadir los encabezados de las columnas
  // XLSX.utils.sheet_add_aoa(worksheet, [
  //   ["Hora", "Nombre", "Hora Inicial", "Hora Final", "Tiempo Disponible"]
  // ], {origin: 'A2'});

  // Añadir los datos comenzando en la tercera fila
  XLSX.utils.sheet_add_json(worksheet, data, {origin: 'A2'});

  // Ajustar el ancho de las columnas
  worksheet['!cols'] = [
    { wpx: 150 },
    { wpx: 250 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 }
  ];

  // Ajustar la altura de la primera fila para el título y las filas de datos
  worksheet['!rows'] = [{ hpx: 30 }, ...data.map(() => ({ hpx: 40 }))];

  // Añadir la hoja al libro
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Detalles');

  // Escribir el libro de trabajo y descargar el archivo
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};





export default ModalQuirofanoDetalle